export default __webpack_public_path__ + "static/media/prepare_for_quad.c00b9c3d.mp3";